import { useRef as u, useMemo as r, useEffect as n } from "../external/preact/hooks/dist/hooks.module.js";
const a = (s) => {
  const e = u(!1), t = r(() => s, [s]);
  return n(() => (e.current = !0, () => {
    e.current = !1, t && t();
  }), [t]), e;
};
export {
  a as default
};
